/* DV_ANATOLIA_EXPERIENCE_20260819 */
(() => {
  "use strict";

  if (window.__dvAnatoliaExperience20260819) return;
  window.__dvAnatoliaExperience20260819 = true;

  const CONFIG_SELECTOR = "[data-dvax-config]";
  const FEATURES = [
    { title: "%100 Doğal Yün:", start: 0.15, end: 1.45, side: "right" },
    { title: "%100 El Dokuma Ustalığı:", start: 1.45, end: 2.75, side: "right" },
    { title: "Anadolu Sanatı & Patchwork Etkisi:", start: 2.75, end: 4.05, side: "left" }
  ];
  const initialized = new WeakSet();

  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function samePath(anchor, path) {
    try {
      return new URL(anchor.href, location.origin).pathname.replace(/\/$/, "") === path.replace(/\/$/, "");
    } catch (_) {
      return false;
    }
  }

  function motionBlocked() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const effectiveType = String(connection && connection.effectiveType || "").toLowerCase();
    return (
      window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
      Boolean(connection && connection.saveData) ||
      effectiveType === "slow-2g" ||
      effectiveType === "2g"
    );
  }

  function buildOverlay(path) {
    const overlay = element("a", "dvax-experience");
    overlay.href = path;
    overlay.setAttribute("aria-label", "Anatolia Serisi koleksiyonuna git");

    const poster = element("img", "dvax-poster");
    poster.alt = "";
    poster.width = 1280;
    poster.height = 720;
    overlay.append(poster);

    const featureLayer = element("div", "dvax-feature-layer");
    featureLayer.setAttribute("aria-hidden", "true");
    const featureNodes = FEATURES.map((feature, featureIndex) => {
      const featureNode = element("div", `dvax-feature is-${feature.side}`);
      featureNode.append(element("span", "dvax-kicker", `ANATOLIA · ${String(featureIndex + 1).padStart(2, "0")}/03`));
      featureNode.append(element("strong", "", feature.title));
      const progress = element("span", "dvax-progress");
      FEATURES.forEach((_, index) => progress.append(element("i", index === featureIndex ? "is-current" : "")));
      featureNode.append(progress);
      featureLayer.append(featureNode);
      return featureNode;
    });
    overlay.append(featureLayer);

    const end = element("div", "dvax-end");
    end.setAttribute("aria-hidden", "true");
    end.append(element("span", "dvax-end-kicker", "MASSIMO · ANATOLIA 3805"));
    end.append(element("strong", "", "Anatolia Serisini Keşfet"));
    const action = element("span", "dvax-action", "Ürünleri Gör ve Satın Al");
    const arrow = element("span", "", "↗");
    arrow.setAttribute("aria-hidden", "true");
    action.append(arrow);
    end.append(action);
    overlay.append(end);

    return { overlay, poster, featureNodes, end };
  }

  function init(config) {
    if (initialized.has(config)) return;
    initialized.add(config);

    const finePointer = window.matchMedia("(min-width: 1150px) and (hover: hover) and (pointer: fine)");
    if (!finePointer.matches) return;

    const path = config.dataset.href || "/collections/massimo-anatolia-serisi";
    const targetSectionId = config.dataset.targetSection || "collections_list_V8gxgU";
    const section = document.querySelector(`[id$="__${targetSectionId}"]`);
    if (!section) return;

    const links = Array.from(section.querySelectorAll("a[href]"));
    const trigger = links.find((anchor) => anchor.classList.contains("hdt-full-width-link") && samePath(anchor, path));
    const media = trigger && trigger.closest(".hdt-collection-img");
    const viewport = trigger && trigger.closest(".hdt-slider__viewport");
    if (!trigger || !media || !viewport) return;

    section.classList.add("dvax-host");
    const { overlay, poster, featureNodes, end } = buildOverlay(path);
    const status = element("span", "dvax-status");
    status.setAttribute("role", "status");
    status.setAttribute("aria-live", "polite");
    viewport.append(overlay);
    section.append(status);

    const state = { open: false, video: null, frameId: null, intervalId: null, activeIndex: -1 };

    function measure() {
      const height = Math.max(1, Math.round(media.getBoundingClientRect().height));
      overlay.style.setProperty("--dvax-media-height", `${height}px`);
    }

    function setActiveFeature(index) {
      if (state.activeIndex === index) return;
      state.activeIndex = index;
      featureNodes.forEach((node, nodeIndex) => node.classList.toggle("is-active", nodeIndex === index));
    }

    function stopFeatureClock() {
      if (state.frameId != null && state.video && typeof state.video.cancelVideoFrameCallback === "function") {
        state.video.cancelVideoFrameCallback(state.frameId);
      }
      if (state.intervalId != null) window.clearInterval(state.intervalId);
      state.frameId = null;
      state.intervalId = null;
    }

    function updateFeature() {
      if (!state.video) return;
      const currentTime = state.video.currentTime;
      const index = FEATURES.findIndex((feature) => currentTime >= feature.start && currentTime < feature.end);
      setActiveFeature(index);
    }

    function startFeatureClock() {
      if (!state.video) return;
      if (typeof state.video.requestVideoFrameCallback === "function") {
        const tick = () => {
          updateFeature();
          if (state.video && !state.video.ended) state.frameId = state.video.requestVideoFrameCallback(tick);
        };
        state.frameId = state.video.requestVideoFrameCallback(tick);
      } else {
        state.intervalId = window.setInterval(updateFeature, 100);
      }
    }

    function showEnd() {
      setActiveFeature(-1);
      stopFeatureClock();
      end.classList.add("is-active");
      end.setAttribute("aria-hidden", "false");
      overlay.setAttribute("aria-label", "Anatolia Serisini keşfet; ürünleri gör ve satın al");
      status.textContent = "Anatolia Serisini keşfedin. Ürünleri görmek ve satın almak için etkinleştirin.";
    }

    function removeVideo() {
      stopFeatureClock();
      if (!state.video) return;
      state.video.pause();
      state.video.removeAttribute("src");
      state.video.querySelectorAll("source").forEach((source) => source.removeAttribute("src"));
      state.video.load();
      state.video.remove();
      state.video = null;
    }

    function close(options = {}) {
      if (!state.open) return;
      state.open = false;
      removeVideo();
      setActiveFeature(-1);
      end.classList.remove("is-active");
      end.setAttribute("aria-hidden", "true");
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-label", "Anatolia Serisi koleksiyonuna git");
      poster.removeAttribute("src");
      status.textContent = "";
      if (options.restoreFocus) trigger.focus({ preventScroll: true });
    }

    function createVideo() {
      const video = element("video", "dvax-video");
      video.muted = true;
      video.playsInline = true;
      video.preload = "auto";
      video.disablePictureInPicture = true;
      video.setAttribute("aria-hidden", "true");

      [
        [config.dataset.webm, "video/webm"],
        [config.dataset.mp4, "video/mp4"]
      ].forEach(([src, type]) => {
        if (!src) return;
        const source = document.createElement("source");
        source.src = src;
        source.type = type;
        video.append(source);
      });

      video.addEventListener("playing", () => {
        video.classList.add("is-visible");
        startFeatureClock();
      }, { once: true });
      video.addEventListener("ended", showEnd, { once: true });
      video.addEventListener("error", showEnd, { once: true });
      poster.after(video);
      state.video = video;
      video.load();
      const playResult = video.play();
      if (playResult && typeof playResult.catch === "function") playResult.catch(showEnd);
    }

    function open(event) {
      if (state.open) return;
      event.preventDefault();
      state.open = true;
      measure();
      poster.src = config.dataset.poster;
      overlay.classList.add("is-open");
      overlay.focus({ preventScroll: true });
      status.textContent = "Anatolia deneyimi açıldı. Koleksiyon ürünlerine gitmek için tekrar etkinleştirin.";

      if (motionBlocked()) {
        showEnd();
        return;
      }
      createVideo();
    }

    trigger.addEventListener("click", open, true);
    window.addEventListener("resize", () => {
      if (state.open) measure();
    }, { passive: true });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) close();
    });
    window.addEventListener("pagehide", () => close());
    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && state.open) close({ restoreFocus: true });
    });

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(([entry]) => {
        if (!entry.isIntersecting) close();
      }, { threshold: 0.05 });
      observer.observe(section);
    }
  }

  function initAll(root = document) {
    root.querySelectorAll(CONFIG_SELECTOR).forEach(init);
  }

  initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
